import * as React from 'react';
import { observer } from 'mobx-react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { ControlIcons } from 'owa-control-icons';
import { getExtendedTheme } from 'owa-fabric-theme';
import { classNamesFunction } from '@uifabric/utilities';

import { getStyles } from './CommonFloatingPickerItem.styles';
import {
    CommonFloatingPickerItemStyleProps,
    CommonFloatingPickerItemStyles,
    CommonFloatingPickerItemProps,
} from './CommonFloatingPickerItem.types';

const getClassNames = classNamesFunction<
    CommonFloatingPickerItemStyleProps,
    CommonFloatingPickerItemStyles
>();

@observer
export default class CommonFloatingPickerItem extends React.Component<
    CommonFloatingPickerItemProps,
    any
> {
    private addSelectedItem = (evt: React.MouseEvent<any>) => {
        evt.preventDefault();
        if (this.props.addPickerItemAction) {
            this.props.addPickerItemAction(this.props.pickerItemData);
        }
    };

    private maskItem = (evt: React.MouseEvent<any>) => {
        evt.preventDefault();
        evt.stopPropagation();

        if (this.props.maskPickerItemAction) {
            this.props.maskPickerItemAction(this.props.pickerItemData);
        }
    };

    render() {
        let {
            isHighlighted,
            personaControl,
            firstLineElement,
            secondLineElement,
            maskPickerItemAction,
            theme = getExtendedTheme(),
        } = this.props;
        const classNames = getClassNames(getStyles, { theme: theme, isHighlighted: isHighlighted });

        return (
            <div className={classNames.container} onClick={this.addSelectedItem}>
                <div className={classNames.personaContainer}>
                    <div className={classNames.personaImage}>{personaControl}</div>
                    <div className={classNames.personaText}>
                        {firstLineElement}
                        {secondLineElement}
                    </div>
                </div>
                {maskPickerItemAction && (
                    <div className={classNames.maskPickerItemButton} onClick={this.maskItem}>
                        <Icon className={classNames.cancelIcon} iconName={ControlIcons.Cancel} />
                    </div>
                )}
            </div>
        );
    }
}
